import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { IconNames } from '../../common/constants/icon-names';
import { FieldErrorMessages } from '../field-error-messages/field-error-messages.component';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-dock-select',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    FieldErrorMessages,
    TranslateModule,
    SvgIconComponent,
    MatSelectModule,
  ],
  templateUrl: './dock-select.component.html',
  styleUrls: ['./dock-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DockSelectComponent<T> implements OnChanges {
  @Input() docks: T[];
  @Input() fieldControl: FormControl<T>;
  @Input() fieldLabel: string;
  @Input() testId: string;
  @Input() disableField = false;
  @Input() isLoadMoreEnabled: boolean;
  @Input() loadMoreAmount = 10;

  @Output() optionSelected: EventEmitter<T> = new EventEmitter();
  @Output() loadMore: EventEmitter<{ more: number; optionAmount: number }> = new EventEmitter();

  iconNames = IconNames;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['docks'] || changes['fieldControl']) {
      this.cdr.markForCheck();
    }
  }

  onOptionSelected(event: MatSelectChange): void {
    this.optionSelected.emit(event.value);
  }

  onLoadMore(): void {
    const optionAmount = this.docks?.length || 0;

    this.loadMore.emit({ more: this.loadMoreAmount, optionAmount });
  }

  compareWithFn = (optionSelected: T | null, optionInDropdown: T | null): boolean => {
    if (
      optionSelected &&
      optionInDropdown &&
      typeof optionSelected === 'object' &&
      typeof optionInDropdown === 'object'
    ) {
      const selected = optionSelected as unknown as { id: unknown };
      const current = optionInDropdown as unknown as { id: unknown };

      return selected.id === current.id;
    }

    return optionSelected === optionInDropdown;
  };
}
